import { useState } from "react";
import { useNavigate } from "react-router-dom";

const quickTags = ["妖精的尾巴", "精灵宝可梦", "夏目友人帐", "狐妖小红娘", "犬夜叉"];

export default function Hero() {
  const navigate = useNavigate();
  const [term, setTerm] = useState("");

  const onSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const t = term.trim();
    if (t) navigate(`/?q=${encodeURIComponent(t)}`);
  };

  return (
    <section className="relative min-h-[560px] md:min-h-[640px] flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=breathtaking%20anime%20fantasy%20landscape%20of%20a%20magical%20forest%20at%20twilight%20with%20glowing%20fairy%20spirits%20and%20soft%20aurora%20lights%2C%20floating%20islands%20and%20luminous%20trees%2C%20warm%20coral%2C%20magenta%20and%20teal%20palette%2C%20dreamy%20stylized%20anime%20background%20artwork&width=1600&height=900&seq=hero-main&orientation=landscape"
          alt="妖精动漫网奇幻森林背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative w-full max-w-7xl mx-auto px-4 md:px-6 py-24 md:py-28 text-center">
        <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur text-white text-sm border border-white/25 animate-fadeUp">
          <i className="ri-sparkling-2-fill text-accent-300"></i>
          妖精 · 精灵 · 妖怪题材奇幻番剧聚合站
        </span>

        <h1 className="mt-6 font-heading text-5xl md:text-7xl text-white leading-tight animate-fadeUp">
          妖精动漫网
        </h1>
        <p className="mt-4 text-lg md:text-xl text-white/90 max-w-2xl mx-auto leading-relaxed animate-fadeUp">
          集中整理妖精、精灵、妖怪题材的奇幻番剧与动画大全。想看妖精的尾巴、精灵宝可梦或冷门妖怪系作品，从这里按题材直接找。
        </p>

        <form
          onSubmit={onSearch}
          className="mt-8 max-w-xl mx-auto flex items-center gap-1 p-1.5 rounded-full bg-white/95 backdrop-blur shadow-card animate-fadeUp"
        >
          <i className="ri-search-line text-xl text-foreground-400 ml-3"></i>
          <input
            type="text"
            value={term}
            onChange={(e) => setTerm(e.target.value)}
            placeholder="输入番剧名称，如：夏目友人帐"
            className="flex-1 min-w-0 h-11 bg-transparent px-2 text-sm md:text-base text-foreground-900 outline-none placeholder-foreground-400"
          />
          <button
            type="submit"
            className="h-11 px-5 md:px-7 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium whitespace-nowrap transition-colors"
          >
            搜索番剧
          </button>
        </form>

        <div className="mt-6 flex items-center justify-center gap-2 flex-wrap animate-fadeUp">
          <span className="text-sm text-white/70">热门：</span>
          {quickTags.map((t) => (
            <button
              key={t}
              type="button"
              onClick={() => navigate(`/?q=${encodeURIComponent(t)}`)}
              className="px-3 py-1 rounded-full text-xs bg-white/15 border border-white/25 text-white hover:bg-white/25 transition-colors cursor-pointer"
            >
              {t}
            </button>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-8 md:gap-12 animate-fadeUp">
          <div>
            <p className="font-heading text-3xl text-white">50+</p>
            <p className="mt-1 text-sm text-white/70">收录番剧</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div>
            <p className="font-heading text-3xl text-white">3</p>
            <p className="mt-1 text-sm text-white/70">奇幻题材</p>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div>
            <p className="font-heading text-3xl text-white">24h</p>
            <p className="mt-1 text-sm text-white/70">持续更新</p>
          </div>
        </div>
      </div>
    </section>
  );
}